import services from './../../services/service'; // Service Class
import validator from './../../services/validator'; // Service
import Preset from './../../mixins/preset.js'; //preset
// import PaymentAndUpdate from './../../mixins/payments_and_updates.js' //payments and updates
import CNpaymentModal from './../CNpaymentModal/index.vue' //payent modal
import CNpaymentModalProcess from './../CNpaymentModal/script.js' //payent modal

let service = new services();
let valid = new validator();

export default {
    name: 'CNInsuranceForm',
    props: {
        cninsurance_listing:Object,
        cninsurance:Object,
    },
    mixins: [Preset, CNpaymentModalProcess],//,PaymentAndUpdate],
    data () {
        return {
            user: {},
            // cninsurance:{},
            set_payment_data:{},
            set_payment_object:{},
            payment_details_data:{},
            component_view:{},
            form_vechicle_classes:{},
            form_policyholder_types:{},
            //car_manufacturers:service.get_car_manufacturers(),
            car_manufacturers:{},
            car_models:{},
            data_processing_message:"",
            terms_cn_agree:false,
            //
        }
    },
    components: {
        "cnpayment-modal": CNpaymentModal
    },
    computed: {},
    methods: {

        //settings
        setComponentView(view,attr1,attr2){
            this.component_view = {};
            this.component_view[view] = true;
            this.jumpToView('topp02');
        },

        //
        getCornerStoneCarCompanies() {
            service.getCornerStoneCarCompanies(this).then(data => {
                if(data.body.status == 200) {
                    this.car_manufacturers = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        getVechicleManufacturerModels(make){ console.log(98122)
            service.getVechicleManufacturerModels(this,make).then(data => {
                if(data.body.status == 200) {
                    this.car_models = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        //use preset
        setFormParams(){
            if(Object.keys(this.cninsurance_listing).length !== 0){
                for(let vc of this.cninsurance_listing.cninsurance_form_variables){
                    //vehicle classs
                    if(vc.cninsurance_form_variable_type_id == 9){
                        this.form_vechicle_classes = vc.cninsurance_form_variable_type_values;
                    }
                    //policyholder type
                    if(vc.cninsurance_form_variable_type_id == 17){
                        this.form_policyholder_types = vc.cninsurance_form_variable_type_values;
                    }
                }
            }
        },

        submitCNInsuranceForm(){
            this.data_processing_message = ""; //reset
            //authen ticate entry
            let error_count = 0;
            if((this.cninsurance.cninsurance_form_first_name == '') ||
                (this.cninsurance.cninsurance_form_last_name == '') ||
                (this.cninsurance.cninsurance_form_gender == '') ||
                (this.cninsurance.cninsurance_form_dob == '') ||
                (this.cninsurance.cninsurance_form_email == '') ||
                (this.cninsurance.cninsurance_form_phone == '') ||
                (this.cninsurance.cninsurance_form_address == '') ||
                (this.cninsurance.cninsurance_form_vehicle_reg_no == '') ||
                (this.cninsurance.cninsurance_form_vehicle_class == '') ||
                (this.cninsurance.cninsurance_form_vehicle_make == '') ||
                (this.cninsurance.cninsurance_form_vehicle_model == '') ||
                (this.cninsurance.cninsurance_form_vehicle_number_plate == '') ||
                (this.cninsurance.cninsurance_form_vehicle_chassis_number == '') ||
                (this.cninsurance.cninsurance_form_vehicle_engine_number == '') ||
                (this.cninsurance.cninsurance_form_year_of_manufacture == '') ||
                (this.cninsurance.cninsurance_form_year_of_purchase == '') ||
                (this.cninsurance.cninsurance_form_policyholder_type == '') 

            ){
                error_count++;
                this.data_processing_message = "Please enter all details with *";
            }else{
                //check if valid email and phone
                //email
                if(!(valid.validateEmail(this.cninsurance.cninsurance_form_email))){
                    error_count++;
                    this.data_processing_message = "Invalid Email";
                }
                //phone
                if(!(valid.validatePhoneNumber(this.cninsurance.cninsurance_form_phone))){
                    error_count++;
                    this.data_processing_message += ", Invalid Phone";
                }  
                //check vechicle class for pricing
                if((this.cninsurance.cninsurance_form_vehicle_class == '') || (this.cninsurance.cninsurance_form_vehicle_class == undefined)){
                    error_count++;
                    this.data_processing_message += ", Please select a Vechicle Class";
                }
                //checkpolicyholder_type for pricing
                if((this.cninsurance.cninsurance_form_policyholder_type == '') || (this.cninsurance.cninsurance_form_policyholder_type == undefined)){
                    error_count++;
                    this.data_processing_message += ", Please select a Policy Holder Type";
                }
                //check years min="1900" max="2099" 
                //--year of manufacture
                if((this.cninsurance.cninsurance_form_year_of_manufacture < 1900) || (this.cninsurance.cninsurance_form_year_of_manufacture > 2099)){
                    error_count++;
                    if(this.data_processing_message !=  ""){
                        this.data_processing_message += ", Year of Manufacture is out of range";
                    }else{
                        this.data_processing_message = "Year of Manufacture is out of range";
                    }
                    
                }
                //--year of purchase
                if((this.cninsurance.cninsurance_form_year_of_purchase < 1900) || (this.cninsurance.cninsurance_form_year_of_purchase > 2099)){
                    error_count++;
                    if(this.data_processing_message !=  ""){
                        this.data_processing_message += ", Year of Purchase is out of range";
                    }else{
                        this.data_processing_message = "Year of Purchase is out of range";
                    }
                    
                }           
            }
                    
            if(error_count == 0){
                //prepare form array sets
                let cnform_array = [];
                //first name
                if(this.cninsurance.cninsurance_form_first_name){
                    let fomr_arr = {
                        form_label:1,
                        form_label_value:this.cninsurance.cninsurance_form_first_name,
                    }
                    cnform_array.push(fomr_arr);
                }
                //last name
                if(this.cninsurance.cninsurance_form_last_name){
                    let fomr_arr = {
                        form_label:2,
                        form_label_value:this.cninsurance.cninsurance_form_last_name,
                    }
                    cnform_array.push(fomr_arr);
                }
                //dob
                if(this.cninsurance.cninsurance_form_dob){
                    let fomr_arr = {
                        form_label:3,
                        form_label_value:this.cninsurance.cninsurance_form_dob,
                    }
                    cnform_array.push(fomr_arr);
                }
                //gender
                if(this.cninsurance.cninsurance_form_gender){
                    let fomr_arr = {
                        form_label:4,
                        form_label_value:this.cninsurance.cninsurance_form_gender,
                    }
                    cnform_array.push(fomr_arr);
                }
                //email
                if(this.cninsurance.cninsurance_form_email){
                    let fomr_arr = {
                        form_label:5,
                        form_label_value:this.cninsurance.cninsurance_form_email,
                    }
                    cnform_array.push(fomr_arr);
                }
                //mobile
                if(this.cninsurance.cninsurance_form_phone){
                    let fomr_arr = {
                        form_label:6,
                        form_label_value:this.cninsurance.cninsurance_form_phone,
                    }
                    cnform_array.push(fomr_arr);
                }
                //address
                if(this.cninsurance.cninsurance_form_address){
                    let fomr_arr = {
                        form_label:7,
                        form_label_value:this.cninsurance.cninsurance_form_address,
                    }
                    cnform_array.push(fomr_arr);
                }
                //vehicle_reg_no
                if(this.cninsurance.cninsurance_form_vehicle_reg_no){
                    let fomr_arr = {
                        form_label:8,
                        form_label_value:this.cninsurance.cninsurance_form_vehicle_reg_no,
                    }
                    cnform_array.push(fomr_arr);
                }
                //vehicle_class
                if(this.cninsurance.cninsurance_form_vehicle_class){
                    let fomr_arr = {
                        form_label:9,
                        form_label_value: this.cninsurance.cninsurance_form_vehicle_class.cninsurance_form_variable_name,
                        form_label_has_variable_id: this.cninsurance.cninsurance_form_vehicle_class.cninsurance_form_variable_id,
                    }
                    cnform_array.push(fomr_arr);
                }
                //vehicle_make
                if(this.cninsurance.cninsurance_form_vehicle_make){
                    let fomr_arr = {
                        form_label:10,
                        form_label_value:this.cninsurance.cninsurance_form_vehicle_make,
                    }
                    cnform_array.push(fomr_arr);
                }
                //vehicle_model
                if(this.cninsurance.cninsurance_form_vehicle_model){
                    let fomr_arr = {
                        form_label:11,
                        form_label_value:this.cninsurance.cninsurance_form_vehicle_model,
                    }
                    cnform_array.push(fomr_arr);
                }
                //vehicle_number_plate
                if(this.cninsurance.cninsurance_form_vehicle_number_plate){
                    let fomr_arr = {
                        form_label:12,
                        form_label_value:this.cninsurance.cninsurance_form_vehicle_number_plate,
                    }
                    cnform_array.push(fomr_arr);
                }
                //vehicle_chassis_number
                if(this.cninsurance.cninsurance_form_vehicle_chassis_number){
                    let fomr_arr = {
                        form_label:13,
                        form_label_value:this.cninsurance.cninsurance_form_vehicle_chassis_number,
                    }
                    cnform_array.push(fomr_arr);
                }
                //vehicle_engine_number
                if(this.cninsurance.cninsurance_form_vehicle_engine_number){
                    let fomr_arr = {
                        form_label:14,
                        form_label_value:this.cninsurance.cninsurance_form_vehicle_engine_number,
                    }
                    cnform_array.push(fomr_arr);
                }
                //year_of_manufacture
                if(this.cninsurance.cninsurance_form_year_of_manufacture){
                    let fomr_arr = {
                        form_label:15,
                        form_label_value:this.cninsurance.cninsurance_form_year_of_manufacture,
                    }
                    cnform_array.push(fomr_arr);
                }
                //year_of_purchase
                if(this.cninsurance.cninsurance_form_year_of_purchase){
                    let fomr_arr = {
                        form_label:16,
                        form_label_value:this.cninsurance.cninsurance_form_year_of_purchase,
                    }
                    cnform_array.push(fomr_arr);
                }
                //policyholder_type
                if(this.cninsurance.cninsurance_form_policyholder_type){
                    let fomr_arr = {
                        form_label:17,
                        // form_label_value:this.cninsurance.cninsurance_form_policyholder_type || 'Private',
                        form_label_value: this.cninsurance.cninsurance_form_policyholder_type.cninsurance_form_variable_name,
                        form_label_has_variable_id: this.cninsurance.cninsurance_form_policyholder_type.cninsurance_form_variable_id,
                    }
                    cnform_array.push(fomr_arr);
                }
                //company_name
                if(this.cninsurance.cninsurance_form_company_name){
                    let fomr_arr = {
                        form_label:18,
                        form_label_value:this.cninsurance.cninsurance_form_company_name,
                    }
                    cnform_array.push(fomr_arr);
                }
                //   
                var payload={
                    cninsurance_company: 1,//this.cninsurance_listing.cninsurance_listing_id,
                    cninsurance_user: this.user.user_id || 0,
                    cninsurance_form: cnform_array,
                    cninsurance_discount: this.cninsurance.cninsurance_discount_code || '',
                }
                if((payload.cninsurance_company > 0) && (payload.cninsurance_form.length > 0)){//submitted form
                    if((this.cninsurance.cninsurance_form_ref) && (this.cninsurance.cninsurance_form_ref != '')){
                        payload.cninsurance_form_ref = this.cninsurance.cninsurance_form_ref;
                        service.postCNinsuranceForm(this, payload).then(data => {
                            if(data.body.status == 200) {
                                // toastr.success("Processing!", "Success!");
                                //MTD2//#PayPostSendForm
                                // this.payment_data = data.body.data_payment_data;
                                // this.payment_data.callback_url = "account-cninsurance";
                                // this.processCNpayment();
                                //MTD2..///#PayPostSendForm

                                //MTD1//#PayPreSendForm
                                if(data.body.data_pay_status == 1){
                                    //payment pending //prompt payment
                                    this.setPaymentMode(data.body.data_payment_data);
                                }else if(data.body.data_pay_status == 0){
                                    //class-msg
                                    this.data_processing_message = "Insurance Form has been submitted successfully";
                                    //set-moda-msg
                                    localStorage.setItem("payment_modal_message","Insurance Form has been submitted successfully");
                                    toastr.success('Insurance Form has been submitted successfully', 'Success!');
                                    this.paymentModalComponentKey++;
                                    let self = this;
                                    setTimeout(function (){
                                        $('#formupdate').modal();
                                        self.paymentModalComponentKey++;
                                    }, 500);
                                }
                                //MTD1..///#PayPreSendForm
                            }else {
                                toastr.error('Sorry, could not process, please check your entries - '+data.body.message, 'Warning!');
                                this.data_processing_message = data.body.message;
                            }
                        }).catch((err) => {
                            if(err) {
                                // console.log(err);
                                toastr.error('Sorry, could not process information, please check entries', 'Warning!');
                            }
                        })
                    }else{//new form
                        service.submitNewCNinsurance(this, payload).then(data => {
                            if(data.body.status == 201) {
                                // toastr.success("Processing!", "Success!");
                                //SET //form-id and other form-update-status-for-resubmission//
                                this.cninsurance.cninsurance_form_ref = data.body.data_cninsurance_form_order_ref;
                                //call auto login
                                if(data.body.data_user_details){
                                    this.logdata = data.body.data_user_details;
                                    this.set_auto_login();
                                }
                                //call payment form ///ALERT IF TXN-REF HAS BEEN used recall payment for a fresh one
                                this.setPaymentMode(data.body.data_payment_data);
                            }else {
                                toastr.error('Sorry, could not process, please check your entries', 'Warning!');
                                this.data_processing_message = data.body.message;
                            }
                        }).catch((err) => {
                            if(err) {
                                // console.log(err);
                                toastr.error('Sorry, could not process information, please check entries', 'Warning!');
                            }
                        })
                    }
                }else{
                    toastr.error('please check your entries', 'Warning!');
                }
            }
        },

        setPaymentMode(payment_data){
            ///show payment breakdown
            this.payment_details_data = payment_data;
            this.setComponentView('paymentDetails','','');
            // this.set_payment_data = payment_data;
            // this.set_payment_data.callback_url = "account-cninsurance";
            // //this.processCNpayment();
            // if((this.set_payment_data.total_amount) && (this.set_payment_data.total_amount > 0)){
            //     this.paymentModalComponentKey++;
            //     // $('#paywith').modal();
            //     setTimeout(function (){
            //         $('#paywith').modal();
            //     }, 10);
            // }else{
            //     this.data_processing_message = "Sorry could not fully submit form, please check your entry, or contact us";
            // }       
        },

        setPaymentModeModal(payment_data){
            this.set_payment_data = payment_data;
            this.set_payment_data.callback_url = "account-cninsurance";
            //this.processCNpayment();
            if((this.set_payment_data.total_amount) && (this.set_payment_data.total_amount > 0)){
                this.paymentModalComponentKey++;
                // $('#paywith').modal();
                setTimeout(function (){
                    $('#paywith').modal();
                }, 10);
            }else{
                this.data_processing_message = "Sorry could not fully submit form, please check your entry, or contact us";
            }    
            //reset view
            this.setComponentView('previewForm','','');   
        },

        setPaymentDetails(){
            this.set_payment_object = {
                payment_detail_type: 'cninsurance',
                payment_detail_name: this.cninsurance_listing.cninsurance_name,
                payment_detail_logo: this.cninsurance_listing.cninsurance_logo,
                payment_detail_set_callbackurl: 'account-cninsurance', //sets
            }
        },

        wn_catch(){
            let issues = localStorage.getItem("reslove_issues");
            this.data_processing_message = issues;
            let r_route = this.$route.params.listing;
            //resolve free
            localStorage.removeItem("reslove_issues");
            localStorage.removeItem("reslove_issues_for");
            //../
            //silently push-back after resolve display
            let cur_rl = this.$router.currentRoute;
            var new_rl = cur_rl.path.replace('/resolve','');
            this.$router.push(new_rl);
            // const { href } = this.$router.resolve(r_route); 
            // window.history.pushState({}, null, href);
            // // history.replaceState(
            // //     {},
            // //     null,
            // //     r_route
            // //     // this.$route.path + '#' + encodeURIComponent(params)
            // // )

            //
            // return issues;
            
        }

    },
    mounted: function(){
        this.setFormParams();
        this.setPaymentDetails();
        this.getCornerStoneCarCompanies();
    },

    created: function(){
        //presets
        this.setComponentView("fillForm","","");
        //for resolve_issues
        let resolve_url = "cninsurance"; //default from account-cninsurance/resolve
        if(this.cninsurance_listing.cninsurance_form_resolve_issues_redirect_url && 
            (this.cninsurance_listing.cninsurance_form_resolve_issues_redirect_url != '') && 
            (this.cninsurance_listing.cninsurance_form_resolve_issues_redirect_url != undefined)){

            resolve_url = this.cninsurance_listing.cninsurance_form_resolve_issues_redirect_url;
        }
        localStorage.setItem("reslove_issues_for",resolve_url);
    }
}


// WEBPACK FOOTER //
// ./src/templates/CNInsuranceForm/script.js